import React from "react";
import "./TrialBox.css";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const TrialBox = () => {
  return (
    <div className="trial-container">
      <h2 className="trial-title">Deneme Sürümünü için İletişime Geç!</h2>
      <p className="trial-subtitle">Deneme Sürümüne Ulaşmak İster misin?</p>
      <Link to="/iletisim" className="trial-button">
        İletişime Geç <FaArrowRight className="trial-arrow-icon" />
      </Link>
    </div>
  );
};

export default TrialBox;
